<template>
    <v-container grid-list-lg fluid>
        <v-layout flex align-center justify-center v-if="reportProcessing">
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="90">
            </v-progress-circular>
            <div>Sauvegarde du rapport en cours</div>
          </v-flex>
        </v-layout>

        <v-layout fuild wrap class="mb-10" align-center v-if="!reportProcessing">
            <v-flex xs12 sm6 md8>
                <h2>GALEC</h2>
                <div class="subheading intervention_dates">Du <strong>{{ report.intervention.start_date_formatted ? report.intervention.start_date_formatted : '__/__/____' }}</strong>
                    <v-dialog
                    persistent
                    v-model="datepickers.intervention_start_date_modal"
                    lazy
                    full-width
                    width="290px">
                        <v-btn fab small slot="activator" class="ml-0 mt-0 mb-0" color="grey lighten-4">
                            <v-icon dark>edit</v-icon>
                        </v-btn>
                        <v-date-picker
                        v-model="report.intervention.start_date"
                        @input="report.intervention.start_date_formatted = formatDate($event)"
                        no-title
                        scrollable
                        actions>
                            <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Annuler</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                            </template>
                        </v-date-picker>
                    </v-dialog>
                    au <strong>{{ report.intervention.end_date_formatted ? report.intervention.end_date_formatted : '__/__/____' }}</strong>
                    <v-dialog
                    persistent
                    v-model="datepickers.intervention_end_date_modal"
                    lazy
                    full-width
                    width="290px">
                        <v-btn fab small slot="activator" class="ml-0 mt-0 mb-0" color="grey lighten-4">
                            <v-icon dark>edit</v-icon>
                        </v-btn>
                        <v-date-picker
                        v-model="report.intervention.end_date"
                        @input="report.intervention.end_date_formatted = formatDate($event)"
                        no-title
                        scrollable
                        actions>
                            <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Annuler</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                            </template>
                        </v-date-picker>
                    </v-dialog>
                </div>
            </v-flex>
            <v-flex xs6 sm3 md2>
                <v-btn color="purple darken-1 elevation-2" block large dark round @click.stop="clientInfosDialog = true">
                    <v-icon left dark>info_outline</v-icon> Client
                </v-btn>
            </v-flex>
            <v-flex xs6 sm3 md2>
                <v-btn color="blue lighten-1 elevation-2" block large dark round @click.stop="dealDialog = true">
                    <v-icon left dark>business_center</v-icon> Affaire
                </v-btn>
            </v-flex>
        </v-layout>

        <v-dialog v-model="clientInfosDialog" max-width="500px">
            <v-card class="form-card elevation-1">
                <v-toolbar class="elevation-0" dense>
                    <v-toolbar-title class="subheading">Client</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.stop="clientInfosDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon>info</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Client</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.client.company_name }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon>location_on</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Adresse</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.client.address }}, {{ report.client.zipCode }}, {{ report.client.city }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon>face</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Contact</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.client.contact.title }} {{ report.client.contact.name }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon>perm_phone_msg</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Tél. contact</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.client.contact.phoneNumber }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dealDialog" max-width="500px">
            <v-card class="form-card elevation-1">
                <v-toolbar class="elevation-0" dense>
                    <v-toolbar-title class="subheading">Affaire</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.stop="dealDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Société de montage</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.deal.company }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Responsable d'affaire</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.deal.owner }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Affaire suivie par</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.deal.manager }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Gestionnaire d'installation</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.deal.contractor }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Liste des CC/XP</v-list-tile-sub-title>
                            <v-list-tile-title>{{ report.deal.cc_xp_list }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-dialog>

        <ClearSignatureDialog
          ref="clear_client_signature"
          signature-reference="client_signature"
          title="Effacement de la signature du client" />

        <ClearSignatureDialog
          ref="clear_team_leader_signature"
          signature-reference="team_leader_signature"
          title="Effacement de la signature du monteur" />

        <ResetFormDialog
          ref="reset_form_dialog" />

        <v-form ref="form" lazy-validation v-if="!reportProcessing">
            <v-card flat class="pb-0 pt-0 mb-3 mt-3 elevation-1 free-card">
                <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                    <v-toolbar-title class="subheading">Type d'intervention</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pb-0 pt-0">
                    <v-radio-group v-model="report.intervention.type">
                        <v-radio label="Phasage initial/complément" value="initial_phasing_or_complement"></v-radio>
                        <v-radio label="Finition" value="finishing"></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-toolbar class="grey lighten-4 elevation-0" dense>
                    <v-toolbar-title class="body-2">Observations</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    {{ report.general_observations ? report.general_observations : '-' }}
                </v-card-text>
            </v-card>

            <v-expansion-panel flat class="elevation-0" expand>
                <v-expansion-panel-content>
                    <div slot="header" class="title">Détails de l'intervention</div>
                    <v-card>
                        <v-card-text class="grey lighten-4">
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Etat du site</v-toolbar-title>
                                        </v-toolbar>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Zone de stockage</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.storage_area.has_storage_area" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            v-if="report.storage_area.has_storage_area == true"
                                            label="Lieu de stockage..."
                                            ref="storage_area__location"
                                            v-model="report.storage_area.location"
                                            :error-messages="storage_area__location_errors"
                                            @input="$v.report.storage_area.location.$touch"
                                            @blur="$v.report.storage_area.location.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Second oeuvre <small>(Plafond, sol, électricité...)</small></v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.second_work.status" row hide-details>
                                                <v-radio label="Prêt" value="ready" class="d-inline-flex"></v-radio>
                                                <v-radio label="En cours" value="in_progress" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non réalisé" value="unrealized" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            v-if="report.second_work.status != 'ready'"
                                            label="Observations..."
                                            ref="second_work__remarks"
                                            v-model="report.second_work.remarks"
                                            multi-line
                                            :error-messages="second_work__remarks_errors"
                                            @input="$v.report.second_work.remarks.$touch"
                                            @blur="$v.report.second_work.remarks.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Contraintes d'accessibilité</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.accessibility_constraints.has_constraints" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            v-if="report.accessibility_constraints.has_constraints == true"
                                            label="Lesquelles..."
                                            ref="accessibility_constraints__remarks"
                                            v-model="report.accessibility_constraints.remarks"
                                            multi-line
                                            :error-messages="accessibility_constraints__remarks_errors"
                                            @input="$v.report.accessibility_constraints.remarks.$touch"
                                            @blur="$v.report.accessibility_constraints.remarks.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Déroulement</v-toolbar-title>
                                        </v-toolbar>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Travaux supplémentaires</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.excess_work.has_excess_work" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Demandeur..."
                                            ref="excess_work__reporter"
                                            v-if="report.excess_work.has_excess_work == true"
                                            v-model="report.excess_work.reporter"
                                            :error-messages="excess_work__reporter_errors"
                                            @input="$v.report.excess_work.reporter.$touch"
                                            @blur="$v.report.excess_work.reporter.$touch"
                                            ></v-text-field>
                                            <v-text-field
                                            label="Interlocuteur..."
                                            ref="excess_work__contact"
                                            v-if="report.excess_work.has_excess_work == true"
                                            v-model="report.excess_work.contact"
                                            :error-messages="excess_work__contact_errors"
                                            @input="$v.report.excess_work.contact.$touch"
                                            @blur="$v.report.excess_work.contact.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Demande de modifications</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.alteration_request.has_alteration_request" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Demandeur..."
                                            ref="alteration_request__reporter"
                                            v-if="report.alteration_request.has_alteration_request == true"
                                            v-model="report.alteration_request.reporter"
                                            :error-messages="alteration_request__reporter_errors"
                                            @input="$v.report.alteration_request.reporter.$touch"
                                            @blur="$v.report.alteration_request.reporter.$touch"
                                            ></v-text-field>
                                            <v-text-field
                                            label="Lesquelles ? Et pourquoi ?"
                                            ref="alteration_request__remarks"
                                            v-if="report.alteration_request.has_alteration_request == true"
                                            v-model="report.alteration_request.remarks"
                                            multi-line
                                            :error-messages="alteration_request__remarks_errors"
                                            @input="$v.report.alteration_request.remarks.$touch"
                                            @blur="$v.report.alteration_request.remarks.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Modification du plan d'implantation</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.implantation_plan_update.has_implantation_plan_update" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Demandeur..."
                                            ref="implantation_plan_update__reporter"
                                            v-if="report.implantation_plan_update.has_implantation_plan_update == true"
                                            v-model="report.implantation_plan_update.reporter"
                                            :error-messages="implantation_plan_update__reporter_errors"
                                            @input="$v.report.implantation_plan_update.reporter.$touch"
                                            @blur="$v.report.implantation_plan_update.reporter.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Livraison(s)</v-toolbar-title>
                                        </v-toolbar>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Retard de livraison</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.late_delivery.has_late_delivery" row hide-details>
                                            <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                            <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Temps d'attente..."
                                            ref="late_delivery__delay"
                                            v-if="report.late_delivery.has_late_delivery == true"
                                            v-model="report.late_delivery.delay"
                                            :error-messages="late_delivery__delay_errors"
                                            @input="$v.report.late_delivery.delay.$touch"
                                            @blur="$v.report.late_delivery.delay.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Déchargement normal</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.unloading.has_normal_unloading" row hide-details>
                                            <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                            <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Pourquoi..."
                                            ref="unloading__remarks"
                                            v-if="report.unloading.has_normal_unloading == false"
                                            v-model="report.unloading.remarks"
                                            multi-line
                                            :error-messages="unloading__remarks_errors"
                                            @input="$v.report.unloading.remarks.$touch"
                                            @blur="$v.report.unloading.remarks.$touch"
                                            ></v-text-field>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Réserves émises</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group
                                            v-model="report.legal_reserves.has_legal_reserves"
                                            row
                                            hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-radio-group
                                            v-model="report.legal_reserves.motivation"
                                            row
                                            ref="legal_reserves__motivation"
                                            v-if="report.legal_reserves.has_legal_reserves == true"
                                            :error-messages="unloading__motivation_errors"
                                            @input="$v.report.legal_reserves.motivation.$touch"
                                            @blur="$v.report.legal_reserves.motivation.$touch">
                                                <v-radio label="Qualité" value="quality" class="d-inline-flex"></v-radio>
                                                <v-radio label="Quantité" value="quantity" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            label="Société de transport si réserve..."
                                            ref="legal_reserves__transport_company"
                                            v-if="report.legal_reserves.has_legal_reserves == true"
                                            v-model="report.legal_reserves.transport_company"
                                            :error-messages="unloading__transport_company_errors"
                                            @input="$v.report.legal_reserves.transport_company.$touch"
                                            @blur="$v.report.legal_reserves.transport_company.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Dossier de montage</v-toolbar-title>
                                        </v-toolbar>

                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Dossier complet</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.project_completion.is_project_completed" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                        </v-card-text>

                                        <v-toolbar class="grey lighten-3 elevation-0" dense v-if="report.project_completion.is_project_completed == false">
                                            <v-toolbar-title class="subheading">Document(s) manquant(s)</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text v-if="report.project_completion.is_project_completed == false">
                                            <v-text-field
                                            label="Liste des documents..."
                                            ref="project_completion__missing_documents"
                                            v-model="report.project_completion.missing_documents"
                                            multi-line
                                            :error-messages="project_completion__missing_documents_errors"
                                            @input="$v.report.project_completion.missing_documents.$touch"
                                            @blur="$v.report.project_completion.missing_documents.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-bind:value="true">
                    <div slot="header" class="title">Réception de l'intervention</div>
                    <v-card>
                        <v-card-text class="grey lighten-4">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Intervention terminée</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-radio-group v-model="report.intervention_completed.is_end_or_work" row hide-details>
                                                <v-radio label="Oui" :value="true" class="d-inline-flex"></v-radio>
                                                <v-radio label="Non" :value="false" class="d-inline-flex"></v-radio>
                                            </v-radio-group>
                                            <v-text-field
                                            v-if="report.intervention_completed.is_end_or_work == false"
                                            ref="intervention_completed__to_be_finished_planned_eta"
                                            label="Temps estimé pour la ré-intervention..."
                                            v-model="report.intervention_completed.to_be_finished_planned_eta"
                                            hint="Nombre de demi-journées"
                                            persistent-hint
                                            :error-messages="project_completion__to_be_finished_planned_eta_errors"
                                            @input="$v.report.intervention_completed.to_be_finished_planned_eta.$touch"
                                            @blur="$v.report.intervention_completed.to_be_finished_planned_eta.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Stockage matériel restant</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-text-field
                                            label="Lieu de stockage..."
                                            ref="equipment__location"
                                            v-model="report.equipment.location"
                                            :error-messages="equipment__location_errors"
                                            @input="$v.report.equipment.location.$touch"
                                            @blur="$v.report.equipment.location.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-text class="pt-0">
                                            <v-switch label="Photo" v-model="report.equipment.has_photo" hide-details></v-switch>
                                        </v-card-text>

                                        <v-card-text class="grey lighten-4" v-if="report.equipment.has_photo == true">
                                            <v-container fluid grid-list-sm>
                                                <v-layout row wrap>
                                                    <v-flex xs3 v-for="(photo, index) in report.equipment.photos" :key="photo.id" style="position: relative;">
                                                        <v-card-text class="pt-0 pr-0 pl-0 pb-0">
                                                            <img class="image" v-bind:src="photo.src" width="100%" height="100%">
                                                            <v-btn
                                                                absolute
                                                                dark
                                                                fab
                                                                top
                                                                right
                                                                small
                                                                color="pink"
                                                                style="right: 14px; top: 14px; z-index: 0px"
                                                                @click="deleteEquipmentPhoto(index)"
                                                                >
                                                                <v-icon>close</v-icon>
                                                            </v-btn>
                                                        </v-card-text>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                            <v-card-text class="text-xs-center white">
                                                <v-btn round large color="cyan" dark @click="getEquipmentPhoto()">Ajouter une photo</v-btn>
                                            </v-card-text>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Emargement client</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="clearSignature('client_signature')">
                                                <v-icon>autorenew</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text class="pt-0 pb-0">
                                            <v-dialog
                                            persistent
                                            v-model="datepickers.client_signature_date_modal"
                                            lazy
                                            full-width
                                            width="290px"
                                            >
                                                <v-text-field
                                                slot="activator"
                                                label="Date..."
                                                v-model="report.signature.date_formatted"
                                                :error-messages="signature__date_formatted_errors"
                                                @input="$v.report.signature.date_formatted.$touch"
                                                readonly
                                                @blur="report.signature.date = parseDate(report.signature.date_formatted)"
                                                ></v-text-field>
                                                <v-date-picker
                                                v-model="report.signature.date"
                                                @input="report.signature.date_formatted = formatDate($event)"
                                                no-title
                                                scrollable
                                                actions
                                                >
                                                    <template slot-scope="{ save, cancel }">
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn flat color="primary" @click="cancel">Annuler</v-btn>
                                                            <v-btn flat color="primary" @click="save">OK</v-btn>
                                                        </v-card-actions>
                                                    </template>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-card-text>
                                        <v-card-text class="pt-0 pb-0">
                                            <v-text-field
                                            label="Nom du signataire..."
                                            ref="signature__client_name"
                                            v-model="report.signature.client_name"
                                            :error-messages="signature__client_name_errors"
                                            @input="$v.report.signature.client_name.$touch"
                                            @blur="$v.report.signature.client_name.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-text v-bind:class="['pt-0', report.intervention_completed.is_end_or_work == false ? 'pb-0' : '']">
                                            <v-text-field
                                            label="Fonction du signataire..."
                                            ref="signature__client_function"
                                            v-model="report.signature.client_function"
                                            :error-messages="signature__client_function_errors"
                                            @input="$v.report.signature.client_function.$touch"
                                            @blur="$v.report.signature.client_function.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-text class="pt-0 pb-0" v-if="report.intervention_completed.is_end_or_work == false">
                                            <v-text-field
                                            label="N° de téléphone du signataire..."
                                            ref="signature__client_phone"
                                            v-model="report.signature.client_phone"
                                            :error-messages="signature__client_phone_errors"
                                            @input="$v.report.signature.client_phone.$touch"
                                            @blur="$v.report.signature.client_phone.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-card-text class="pt-0" v-if="report.intervention_completed.is_end_or_work == false">
                                            <v-text-field
                                            label="Email du signataire..."
                                            ref="signature__client_email"
                                            v-model="report.signature.client_email"
                                            :error-messages="signature__client_email_errors"
                                            @input="$v.report.signature.client_email.$touch"
                                            @blur="$v.report.signature.client_email.$touch"
                                            ></v-text-field>
                                        </v-card-text>
                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Signature</v-toolbar-title>
                                        </v-toolbar>
                                        <SignaturePad ref="client_signature" :h="'400px'"></SignaturePad>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-bind:value="true">
                    <div slot="header" class="title">Photos</div>
                    <v-card>
                        <v-card-text class="grey lighten-4">
                            <v-container fluid grid-list-sm>
                                <v-layout row wrap>
                                    <v-flex xs3 v-for="(photo, index) in report.photos" :key="photo.id" style="position: relative;">
                                        <v-card-text class="pt-0 pr-0 pl-0 pb-0">
                                            <img class="image" v-bind:src="photo.src" width="100%" height="100%">
                                            <v-btn
                                                absolute
                                                dark
                                                fab
                                                top
                                                right
                                                small
                                                color="pink"
                                                style="right: 14px; top: 14px; z-index: 0px"
                                                @click="deletePhoto(index)"
                                                >
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </v-card-text>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-card-text class="text-xs-center white">
                                <v-btn round large color="cyan" dark @click="getPhoto()">Ajouter une photo</v-btn>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-bind:value="true">
                    <div slot="header" class="title">Signature intervenant</div>
                    <v-card>
                        <v-card-text class="grey lighten-4">
                            <v-alert color="warning pt-2 elevation-1" icon="priority_high" value="true">
                                Le visa du chef d'équipe l'engage sur le fait que l'ensemble du mobilier installé est sécurisé (Organes de sécurité en place : Scellements, clous verrouillage,...)
                            </v-alert>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Observations</v-toolbar-title>
                                        </v-toolbar>

                                        <v-card-text class="pb-0">
                                            <v-switch label="Appel de nuit mobilier n°03-86-53-49-00" v-model="report.observations.night_calls_furniture"></v-switch>
                                            <v-switch label="Appel de nuit caisses n°02-54-23-13-00" v-model="report.observations.night_calls_cashregisters"></v-switch>
                                            <v-switch label="Compte rendu photo" v-model="report.observations.picture_report"></v-switch>
                                            <v-switch label="PP retourné, signé" v-model="report.observations.is_returned_project_signed"></v-switch>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card class="form-card elevation-1">
                                        <v-toolbar dark class="deep-purple darken-1 elevation-0" dense>
                                            <v-toolbar-title class="subheading">Signature chef d'équipe de pose</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="clearSignature('team_leader_signature')">
                                                <v-icon>autorenew</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text class="pt-0">
                                            <v-select
                                            v-bind:items="teamLeaders"
                                            item-text="name"
                                            item-value="id"
                                            return-object
                                            v-model="report.team_leader.name"
                                            ref="team_leader__name"
                                            label="Sélectionner un chef d'équipe..."
                                            single-line
                                            bottom
                                            :error-messages="team_leader__name_errors"
                                            @input="$v.report.team_leader.name.$touch"
                                            @blur="$v.report.team_leader.name.$touch"
                                            ></v-select>
                                        </v-card-text>
                                        <v-toolbar class="grey lighten-4 elevation-0" dense>
                                            <v-toolbar-title class="body-2">Signature</v-toolbar-title>
                                        </v-toolbar>
                                        <SignaturePad ref="team_leader_signature" :h="'400px'"></SignaturePad>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-bind:value="true">
                    <div slot="header" class="title">Suivi chantier mobilier</div>
                    <v-card>
                        <v-card-text class="grey lighten-4 text-xs-center pt-1" v-if="report.intervention_completed.is_end_or_work === false">
                            <v-card class="form-card elevation-1 mt-5" v-for="(visit_report, index) in report.visit_reports" :key="visit_report.id">
                                <v-card-text class="pt-0">
                                    <v-text-field
                                    label="Zone..."
                                    v-model="visit_report.zone"
                                    hide-details
                                    ></v-text-field>
                                    <v-text-field
                                    label="N° gondole..."
                                    v-model="visit_report.gondola_number"
                                    hide-details
                                    ></v-text-field>
                                    <v-text-field
                                    label="Description du besoin..."
                                    v-model="visit_report.requirement_description"
                                    multi-line
                                    hide-details
                                    ></v-text-field>
                                    <v-text-field
                                    label="Code article..."
                                    v-model="visit_report.item_code"
                                    hide-details
                                    ></v-text-field>
                                    <v-switch label="Montage" class="mt-3" v-model="visit_report.is_assembled_by_originator" hide-details></v-switch>
                                    <v-switch label="NRF" v-model="visit_report.is_nrf" hide-details></v-switch>
                                    <v-text-field
                                    label="Motif NRF..."
                                    v-model="visit_report.nrf_cause"
                                    hide-details
                                    ></v-text-field>
                                    <v-switch label="Devis" v-model="visit_report.has_quotation" hide-details></v-switch>
                                    <v-text-field
                                    label="Délai souhaité..."
                                    v-model="visit_report.desired_time_limit"
                                    hide-details
                                    ></v-text-field>
                                    <v-btn
                                    absolute
                                    dark
                                    fab
                                    top
                                    right
                                    small
                                    color="pink"
                                    @click="deleteVisitReport(index)"
                                    >
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                            <v-btn fab dark color="indigo mt-3" @click="addVisitReport">
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-card-text>

                        <v-card-text class="grey lighten-4 text-xs-center pt-1">
                            <v-card class="form-card elevation-1 mt-0">
                                <v-card-text class="pt-0">
                                    <v-text-field
                                    label="observations supplémentaires..."
                                    v-model="report.additional_observations"
                                    multi-line
                                    hide-details
                                    ></v-text-field>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-card flat>
                <v-card-text class="text-xs-center pl-0 pr-0">
                    <v-btn large round flat @click="showResetDialog">Réinitialiser</v-btn>
                    <v-btn large round dark color="pink darken-1 elevation-2" @click="submit">Envoyer</v-btn>
                </v-card-text>
            </v-card>
        </v-form>

        <v-snackbar
            top
            color="pink darken-1"
            multi-line
            v-model="errors_snackbar">
            {{ errors }}
            <v-btn flat color="pink lighten-4" @click.native="errors_snackbar = false">Fermer</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength, numeric, email } from 'vuelidate/lib/validators'
  import SignaturePad from '@/components/Tools/SignaturePad'
  import ClearSignatureDialog from '@/components/Report/ClearSignatureDialog'
  import ResetFormDialog from '@/components/Report/ResetFormDialog'
  import _ from 'lodash'

  export default {
    mixins: [validationMixin],
    components: { SignaturePad, ClearSignatureDialog, ResetFormDialog },
    validations () {
      return {
        report: {
          storage_area: {
            location: {
              ...this.report.storage_area.has_storage_area === true && { required },
              minLength: minLength(2)
            }
          },
          second_work: {
            remarks: {
              ...this.report.second_work.status !== 'ready' === true && { required },
              minLength: minLength(2)
            }
          },
          accessibility_constraints: {
            remarks: {
              ...this.report.accessibility_constraints.has_constraints === true && { required },
              minLength: minLength(2)
            }
          },
          excess_work: {
            reporter: {
              ...this.report.excess_work.has_excess_work === true && { required },
              minLength: minLength(2)
            },
            contact: {
              ...this.report.excess_work.has_excess_work === true && { required },
              minLength: minLength(2)
            }
          },
          alteration_request: {
            reporter: {
              ...this.report.alteration_request.has_alteration_request === true && { required },
              minLength: minLength(2)
            },
            remarks: {
              ...this.report.alteration_request.has_alteration_request === true && { required },
              minLength: minLength(2)
            }
          },
          implantation_plan_update: {
            reporter: {
              ...this.report.implantation_plan_update.has_implantation_plan_update === true && { required },
              minLength: minLength(2)
            }
          },
          late_delivery: {
            delay: {
              ...this.report.late_delivery.has_late_delivery === true && { required },
              numeric: numeric
            }
          },
          unloading: {
            remarks: {
              ...this.report.unloading.has_normal_unloading === false && { required },
              minLength: minLength(2)
            }
          },
          legal_reserves: {
            motivation: {
              ...this.report.legal_reserves.has_legal_reserves === true && { required }
            },
            transport_company: {
              ...this.report.legal_reserves.has_legal_reserves === true && { required },
              minLength: minLength(2)
            }
          },
          project_completion: {
            missing_documents: {
              ...this.report.project_completion.is_project_completed === false && { required },
              minLength: minLength(2)
            }
          },
          intervention_completed: {
            to_be_finished_planned_eta: {
              ...this.report.intervention_completed.is_end_or_work === false && { required },
              numeric: numeric
            }
          },
          equipment: {
            location: {
              required,
              minLength: minLength(2)
            }
          },
          signature: {
            date_formatted: {
              required
            },
            client_name: {
              required,
              minLength: minLength(2)
            },
            client_function: {
              required,
              minLength: minLength(2)
            },
            client_phone: {
              ...this.report.intervention_completed.is_end_or_work === false && { required }
            },
            client_email: {
              ...this.report.intervention_completed.is_end_or_work === false && { required },
              email
            }
          },
          team_leader: {
            name: {
              required
            }
          }
        }
      }
    },
    data () {
      return {
        // Clean copy of the object located in the store
        report: JSON.parse(JSON.stringify(this.$store.getters.getReport(this.id))),
        clientInfosDialog: false,
        errors_snackbar: false,
        errors: '',
        dealDialog: false,
        // affichage du datepicker
        datepickers: {
          client_signature_date_modal: false,
          intervention_start_date_modal: false,
          intervention_end_date_modal: false
        },
        teamLeaders: [
          { id: 1, name: 'Chef d\'équipe 1' },
          { id: 2, name: 'Chef d\'équipe 2' },
          { id: 3, name: 'Chef d\'équipe 3' },
          { id: 4, name: 'Chef d\'équipe 4' },
          { id: 5, name: 'Chef d\'équipe 5' }
        ]
      }
    },
    props: ['id'],
    computed: {
      // Validation errors
      storage_area__location_errors () {
        const errors = []
        if (!this.$v.report.storage_area.location.$dirty) return errors
        !this.$v.report.storage_area.location.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.storage_area.location.required && errors.push('Le champ est requis.')
        return errors
      },
      second_work__remarks_errors () {
        const errors = []
        if (!this.$v.report.second_work.remarks.$dirty) return errors
        !this.$v.report.second_work.remarks.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.second_work.remarks.required && errors.push('Le champ est requis.')
        return errors
      },
      accessibility_constraints__remarks_errors () {
        const errors = []
        if (!this.$v.report.accessibility_constraints.remarks.$dirty) return errors
        !this.$v.report.accessibility_constraints.remarks.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.accessibility_constraints.remarks.required && errors.push('Le champ est requis.')
        return errors
      },
      excess_work__reporter_errors () {
        const errors = []
        if (!this.$v.report.excess_work.reporter.$dirty) return errors
        !this.$v.report.excess_work.reporter.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.excess_work.reporter.required && errors.push('Le champ est requis.')
        return errors
      },
      excess_work__contact_errors () {
        const errors = []
        if (!this.$v.report.excess_work.contact.$dirty) return errors
        !this.$v.report.excess_work.contact.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.excess_work.contact.required && errors.push('Le champ est requis.')
        return errors
      },
      alteration_request__reporter_errors () {
        const errors = []
        if (!this.$v.report.alteration_request.reporter.$dirty) return errors
        !this.$v.report.alteration_request.reporter.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.alteration_request.reporter.required && errors.push('Le champ est requis.')
        return errors
      },
      alteration_request__remarks_errors () {
        const errors = []
        if (!this.$v.report.alteration_request.remarks.$dirty) return errors
        !this.$v.report.alteration_request.remarks.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.alteration_request.remarks.required && errors.push('Le champ est requis.')
        return errors
      },
      implantation_plan_update__reporter_errors () {
        const errors = []
        if (!this.$v.report.implantation_plan_update.reporter.$dirty) return errors
        !this.$v.report.implantation_plan_update.reporter.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.implantation_plan_update.reporter.required && errors.push('Le champ est requis.')
        return errors
      },
      late_delivery__delay_errors () {
        const errors = []
        if (!this.$v.report.late_delivery.delay.$dirty) return errors
        !this.$v.report.late_delivery.delay.required && errors.push('Le champ est requis.')
        !this.$v.report.late_delivery.delay.numeric && errors.push('Le champ doit être numérique.')
        return errors
      },
      unloading__remarks_errors () {
        const errors = []
        if (!this.$v.report.unloading.remarks.$dirty) return errors
        !this.$v.report.unloading.remarks.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.unloading.remarks.required && errors.push('Le champ est requis.')
        return errors
      },
      unloading__motivation_errors () {
        const errors = []
        if (!this.$v.report.legal_reserves.motivation.$dirty) return errors
        !this.$v.report.legal_reserves.motivation.required && errors.push('Le champ est requis.')
        return errors
      },
      unloading__transport_company_errors () {
        const errors = []
        if (!this.$v.report.legal_reserves.transport_company.$dirty) return errors
        !this.$v.report.legal_reserves.transport_company.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.legal_reserves.transport_company.required && errors.push('Le champ est requis.')
        return errors
      },
      project_completion__missing_documents_errors () {
        const errors = []
        if (!this.$v.report.project_completion.missing_documents.$dirty) return errors
        !this.$v.report.project_completion.missing_documents.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.project_completion.missing_documents.required && errors.push('Le champ est requis.')
        return errors
      },
      project_completion__to_be_finished_planned_eta_errors () {
        const errors = []
        if (!this.$v.report.intervention_completed.to_be_finished_planned_eta.$dirty) return errors
        !this.$v.report.intervention_completed.to_be_finished_planned_eta.required && errors.push('Le champ est requis.')
        !this.$v.report.intervention_completed.to_be_finished_planned_eta.numeric && errors.push('Le champ doit être numérique.')
        return errors
      },
      equipment__location_errors () {
        const errors = []
        if (!this.$v.report.equipment.location.$dirty) return errors
        !this.$v.report.equipment.location.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.equipment.location.required && errors.push('Le champ est requis.')
        return errors
      },
      signature__date_formatted_errors () {
        const errors = []
        if (!this.$v.report.signature.date_formatted.$dirty) return errors
        !this.$v.report.signature.date_formatted.required && errors.push('Le champ est requis.')
        return errors
      },
      signature__client_name_errors () {
        const errors = []
        if (!this.$v.report.signature.client_name.$dirty) return errors
        !this.$v.report.signature.client_name.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.signature.client_name.required && errors.push('Le champ est requis.')
        return errors
      },
      signature__client_function_errors () {
        const errors = []
        if (!this.$v.report.signature.client_function.$dirty) return errors
        !this.$v.report.signature.client_function.minLength && errors.push('Le champ doit être composée d\'au moins 2 caractères')
        !this.$v.report.signature.client_function.required && errors.push('Le champ est requis.')
        return errors
      },
      signature__client_phone_errors () {
        const errors = []
        if (!this.$v.report.signature.client_phone.$dirty) return errors
        !this.$v.report.signature.client_phone.required && errors.push('Le champ est requis.')
        return errors
      },
      signature__client_email_errors () {
        const errors = []
        if (!this.$v.report.signature.client_email.$dirty) return errors
        !this.$v.report.signature.client_email.email && errors.push('Le champ doit être un email valide')
        !this.$v.report.signature.client_email.required && errors.push('Le champ est requis.')
        return errors
      },
      team_leader__name_errors () {
        const errors = []
        if (!this.$v.report.team_leader.name.$dirty) return errors
        !this.$v.report.team_leader.name.required && errors.push('Le champ est requis.')
        return errors
      },
      reportProcessing () {
        return this.$store.getters.reportProcessing
      }
    },
    mounted () {
      this.loadLogo()

      this.restoreSignatures()
    },
    updated () {
      this.loadLogo()
    },
    destroyed () {
      this.hideLogo()
    },
    methods: {
      restoreSignature (signatureImg, ref) {
        const canvas = document.getElementById(this.$refs[ref].uid)
        const context = canvas.getContext('2d')
        const img = new Image()
        img.onload = function () {
          context.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height)
        }
        img.src = signatureImg
      },
      restoreSignatures () {
        this.restoreSignature(this.report.signature.signature, 'client_signature')
        this.restoreSignature(this.report.team_leader.signature, 'team_leader_signature')
      },
      getEquipmentPhoto () {
        navigator.camera.getPicture(this.getEquipmentPhotoSuccess, this.getEquipmentPhotoFailure, {
          destinationType: Camera.DestinationType.DATA_URL
        })
      },
      getEquipmentPhotoSuccess (imageData) {
        this.report.equipment.photos.push({
          id: null,
          src: 'data:image/jpeg;base64,' + imageData
        })
      },
      getEquipmentPhotoFailure (error) {
        console.log(error)
      },
      getPhoto () {
        navigator.camera.getPicture(this.getPhotoSuccess, this.getPhotoFailure, {
          destinationType: Camera.DestinationType.DATA_URL
        })
      },
      getPhotoSuccess (imageData) {
        this.report.photos.push({
          id: null,
          src: 'data:image/jpeg;base64,' + imageData
        })
      },
      getPhotoFailure (error) {
        console.log(error)
      },
      deleteVisitReport (index) {
        this.report.visit_reports.splice(index, 1)
      },
      addVisitReport () {
        if (!_.has(this.report, 'visit_reports')) {
          this.$set(this.report, 'visit_reports', [])
        }

        this.report.visit_reports.push({
          zone: null,
          gondola_number: null,
          requirement_description: null,
          item_code: null,
          is_assembled_by_originator: false,
          is_nrf: false,
          nrf_cause: null,
          has_quotation: false,
          desired_time_limit: null
        })
      },
      loadLogo () {
        this.$emit('loadLogo', this.report.originator.logo)
      },
      hideLogo () {
        this.$emit('loadLogo', null)
      },
      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) {
          return null
        }

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      showResetDialog () {
        this.$refs['reset_form_dialog'].dialog = true
      },
      reset () {
        this.$v.$reset()
        this.report = JSON.parse(JSON.stringify(this.$store.getters.getReport(this.id)))
        this.restoreSignatures()
      },
      isEmptySignature (signatureField) {
        let canvas = signatureField.$el.childNodes[0]
        let blank = document.createElement('canvas')
        blank.width = canvas.width
        blank.height = canvas.height

        return canvas.toDataURL() === blank.toDataURL()
      },
      submit () {
        // Validate form data
        this.$v.$touch()

        if (this.$v.$error === true) {
          // recherche et focus sur le premier champ en erreur
          const report = this.$v.report
          _.keys(report.$params).map((groupFieldname) => {
            _.keys(report[groupFieldname].$params).map((fieldName) => {
              if (report[groupFieldname][fieldName].$error === true) {
                this.$refs[`${groupFieldname}__${fieldName}`].focus()
              }
            })
          })

          this.errors = 'Certains champs du formulaire contiennent des erreurs !'
          this.errors_snackbar = true
          return
        }

        if (!this.report.intervention.start_date || !this.report.intervention.end_date) {
          this.errors = 'Veuillez renseigner les dates d\'intervention !'
          this.errors_snackbar = true
          return
        }

        if (this.isEmptySignature(this.$refs.client_signature) === true) {
          this.errors = 'Il manque la signature du client !'
          this.errors_snackbar = true
          return
        }

        if (this.isEmptySignature(this.$refs.team_leader_signature) === true) {
          this.errors = 'Il manque la signature du chef d\'équipe de pose !'
          this.errors_snackbar = true
          return
        }

        this.report.signature.signature = this.$refs.client_signature.save()
        this.report.team_leader.signature = this.$refs.team_leader_signature.save()
        this.report.state = 'signed'

        this.$store.dispatch('saveReport', this.report).then(() => {
          this.$router.push({
            name: 'reports', params: { reportProcessingStatus: 'success' }
          })
        })
      },
      clearSignature (ref) {
        this.$refs[`clear_${ref}`].dialog = true
        // var _this = this
        // _this.$refs[ref].clear()
      },
      deletePhoto (index) {
        this.report.photos.splice(index, 1)
      },
      deleteEquipmentPhoto (index) {
        this.report.equipment.photos.splice(index, 1)
      }
    }
  }
</script>

<style>
  .signature-pad {
    height: 400px
  }

  /* Tablettes & + */
  @media only screen and (min-device-width: 601px) {
    .flex-left {
      padding-right: 0 !important;
    }

    .flex-right {
      padding-left: 0 !important;
    }
  }

  /* Petits écrans (smartphones) */
  @media only screen and (max-device-width: 600px) {
    .flex-left {
      padding-bottom: 0 !important;
    }

    .flex-right {
      padding-top: 0 !important;
    }
  }

  .intervention_dates .dialog__container {
    display: inline-block !important;
  }

  .stepper--vertical .stepper__content {
    margin-left: 12px !important;
    padding-right: 20px !important;
  }

  .expansion-panel__header {
    color: #939c9f;
    font-weight: 400;
    padding-left: 0;
    padding-right: 0;
  }

  .expansion-panel__header .icon {
    color:#939c9f !important;
  }

  .expansion-panel__container--active .expansion-panel__header .title,
  .expansion-panel__container--active .expansion-panel__header .icon {
    font-weight: 500 !important;
    color: #333;
  }

  .expansion-panel .expansion-panel__container {
    border-top-color: #F4F5F7 !important;
  }

  .fields-group-label {
    font-size: 1.1em;
    border-bottom: #e5e5e5 1px solid;
  }

  .jumbo-toggle-button-item {
    width: 100% !important;
    height: 60px;
  }

  .display-field-label {
    font-weight: 700;
  }

  .alert.warning,
  .free-card,
  .form-card {
    border-radius: 6px !important;
  }

  .form-card .layout .card__text {
    padding-top: 2px;
    padding-bottom: 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Report/EditReport.vue